module.exports = __webpack_public_path__ + "img/alpaca.fb21f66d.jpg";